import { useLocation } from '@tanstack/react-router';

import { AppShell } from './app-shell';

import { useUser } from '@/firebase';

export function ConditionalAppShell({ children }: { children: React.ReactNode }) {
  const { user } = useUser();
  const { pathname } = useLocation();

  // Don't wrap in AppShell if:
  // - User is not authenticated AND
  // - We're on the root path (marketing homepage) or login page
  const isReaderRoute = pathname.startsWith('/library') || pathname.startsWith('/read');
  const isAccountRecoveryRoute =
    pathname === '/account-pending-deletion' || pathname === '/restore-account';
  const shouldWrapInAppShell =
    (user || (pathname !== '/' && pathname !== '/login')) &&
    !isReaderRoute &&
    !isAccountRecoveryRoute;

  if (shouldWrapInAppShell) {
    return <AppShell>{children}</AppShell>;
  }

  return <>{children}</>;
}
